export const CASE_FILTER_OPTIONS = [
  {
    value: "FAVORITE",
    label: "Избранное",
  },
  {
    value: "ARCHIVED",
    label: "Архив",
  },
];

export const GENDER_OPTIONS = [
  {
    value: "MALE",
    label: "MALE",
  },
  {
    value: "FEMALE",
    label: "FEMALE",
  },
];

export const RACE_OPTIONS = [
  {
    value: "AFRICAN",
    label: "race_african",
  },
  {
    value: "EUROPEAN",
    label: "race_european",
  },
  {
    value: "ASIAN",
    label: "race_asian",
  },
  {
    value: "HISPANIC",
    label: "race_hispanic",
  },
];
